import { useEffect } from "react";
import { AppToasterV2, MultiStepItemProps } from "@ucl/library";
import { useKeyPeople } from "@/hooks/useKeyPeople";
import { KeyPeople } from "./KeyPeople";
import { RequireAuth } from "@/lib/auth/RequireAuth";
import { FinancialApplicationFormSectionContextType } from "@/hooks/useFinancialApplicationFormSectionValidation";

export interface KeyPeopleStepProps extends MultiStepItemProps {
  financialApplicationId: string;
}

export const KeyPeopleStep: React.FC<KeyPeopleStepProps> = (props) => {
  return (
    <RequireAuth clientType="consumer">
      <KeyPeopleStepInner {...props} />
    </RequireAuth>
  );
};

const KeyPeopleStepInner: React.FC<KeyPeopleStepProps> = (props) => {
  const { validateKeyPeople } = useKeyPeople(props.financialApplicationId);

  useEffect(() => {
    props.registerSubmit?.(async () => {
      const doNotHaveValidationErrors = await validateKeyPeople();

      if (!doNotHaveValidationErrors) {
        AppToasterV2.showFailedActionToaster(
          "Please correct the highlighted fields to proceed.",
          "Action Required"
        );
      }
      return doNotHaveValidationErrors;
    });
  }, [props.financialApplicationId, validateKeyPeople]);

  return (
    <section className="key-people-info step-section">
      <div className="key-people-info__header step-header">
        Key People Information
      </div>
      <div className="key-people-info__subtitle step-subtitle">
        Please provide information about the individuals who own, control, or are authorized
        to act on behalf of your entity.
      </div>
      <KeyPeople
        financialApplicationId={props.financialApplicationId}
        validationContextType={FinancialApplicationFormSectionContextType.Applicant}
        shouldHideSecurityQuestions={true}
        shouldAskIfCanProvideGovernmentIdInformation={true}
      />
    </section>
  );
};
